/** Bind deployment configuration once; callers cannot supply an analytics destination. */
export function createAnalyticsHeaders(getWindow, getConfig) {
  return async (url, method) => {
    try {
      const target = getWindow();
      const consent = () => {
        const cookie = target.document.cookie
          .split(";")
          .map(value => value.trim())
          .find(value => value.startsWith("cookie_consent_level="));
        return (
          !!cookie && JSON.parse(decodeURIComponent(cookie.slice("cookie_consent_level=".length))).tracking === true
        );
      };
      if (!target || method.toUpperCase() !== "POST" || !consent()) return {};
      const config = getConfig();
      const base = new URL(config.CUSTOM_API_URL);
      const request = new URL(url);
      const prefix = base.pathname.replace(/\/$/, "");
      if (request.origin !== base.origin || !request.pathname.startsWith(`${prefix}/`)) return {};
      if (!/^\/(?:events\/[^/]+\/registrations|products\/[^/]+\/checkout)$/.test(request.pathname.slice(prefix.length)))
        return {};
      const id = config.GA4_GLOBAL_MEASUREMENT_ID;
      if (typeof id !== "string" || !/^G-[A-Z0-9]+$/.test(id) || typeof target.gtag !== "function") return {};
      const read = field =>
        new Promise(resolve => {
          const timer = setTimeout(() => resolve(undefined), 250);
          try {
            target.gtag("get", id, field, value => {
              clearTimeout(timer);
              resolve(value);
            });
          } catch (error) {
            clearTimeout(timer);
            resolve(undefined);
          }
        });
      const [client, session] = await Promise.all([read("client_id"), read("session_id")]);
      if (!consent() || typeof client !== "string" || !/^[0-9]{1,20}\.[0-9]{1,20}$/.test(client)) return {};
      const sessionId = typeof session === "number" ? String(session) : session;
      return {
        "X-Onland-Analytics": JSON.stringify({
          client_id: client,
          ...(typeof sessionId === "string" && /^[0-9]{1,20}$/.test(sessionId) ? { session_id: sessionId } : {}),
          consent: true,
          app_source: "runtime"
        })
      };
    } catch (error) {
      return {};
    }
  };
}
